export default "__VITE_ASSET__p9EL430L__"